//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFormTextAlignCenter(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5 5H19V7H5V5ZM8 9H16V11H8V9ZM16 17H8V19H16V17ZM5 13H19V15H5V13Z" fill="currentColor" /></svg>;
}
export default IconFormTextAlignCenter;